export { CashFlowPageTemplate as default } from './CashFlowPageTemplate';
